export default __webpack_public_path__ + "static/Concept-2-fd54e4f901de728a81a1fc08c718714e.jpg";